import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["summary", "elements", "id", "formLoop", "value", "expanded", "summaryProps", "detailPanelProps", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AccordionSummary, Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import { useCallback } from "react";
import { ChevronDownIcon } from "../../../../assets/customIcons";
export var FormAccordion = function (props) {
    var summary = props.summary, elements = props.elements, id = props.id, _a = props.formLoop, formLoop = _a === void 0 ? function () { return undefined; } : _a, value = props.value, _b = props.expanded, expanded = _b === void 0 ? value : _b, summaryProps = props.summaryProps, detailPanelProps = props.detailPanelProps, onChange = props.onChange, others = _objectWithoutProperties(props, _excluded);
    var getFormElements = useCallback(function (formElements) {
        if (Array.isArray(formElements))
            return formElements.map(formLoop);
        return formElements;
    }, [formLoop]);
    return /*#__PURE__*/ React.createElement(Accordion, _extends({
        expanded: expanded,
        onChange: onChange,
        slotProps: {
            transition: {
                mountOnEnter: true
            }
        },
        variant: "outlined",
        disableGutters: true,
        square: true
    }, others, {
        sx: _objectSpread({
            borderRadius: 2
        }, others.sx)
    }), /*#__PURE__*/ React.createElement(AccordionSummary, _extends({
        id: id,
        expandIcon: /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            fontSize: "small"
        }),
        disableRipple: true
    }, summaryProps), getFormElements(summary)), /*#__PURE__*/ React.createElement(Grid, _extends({
        container: true,
        spacing: 2
    }, detailPanelProps), getFormElements(elements)));
};
